import { render, staticRenderFns } from "./EmbeddedComplete.vue?vue&type=template&id=0bf817da&"
import script from "./EmbeddedComplete.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports